module.exports = __webpack_public_path__ + "components/flag/static/square/bn-02d714b20e2919693031f27355d9dbf1.svg";